import "./Label.scss";

const Label = ({ StyleClassName, text }) => {
  return <span className={StyleClassName}>{text}</span>;
};

export default Label;
